{
  "version": 1,
  "asset_id": "282db532-500b-4071-8127-ac4ad9976d56",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/282db532-500b-4071-8127-ac4ad9976d56/svc-link-building-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/282db532-500b-4071-8127-ac4ad9976d56/svc-link-building-1200.avif",
  "original_filename": "svc-link-building-1200.avif",
  "size": 16363,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:50Z"
}
